import { render, staticRenderFns } from "./ModsGuide.vue?vue&type=template&id=45514cb4&scoped=true&"
import script from "./ModsGuide.vue?vue&type=script&lang=js&"
export * from "./ModsGuide.vue?vue&type=script&lang=js&"
import style0 from "./ModsGuide.vue?vue&type=style&index=0&id=45514cb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45514cb4",
  null
  
)

export default component.exports